import React from "react";
import PropTypes from "prop-types";
import NeoLoader from "./NeoLoader";

/**
 * PageLoader
 * Spinner de página inteira herdando as animações premium de NeoLoader.
 */
const PageLoader = ({ loading = true }) => {
    return <NeoLoader type="full-page" loading={loading} />;
};

PageLoader.propTypes = {
    loading: PropTypes.bool
};

export default PageLoader;

